// Wait until the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function () {
  
  setTimeout(function () {
    // Select the currency element
    const currencyEl = document.querySelector(".pick_currency.mldesk");
    // Select the footer (adjust the selector if needed)
    const footer = document.querySelector("footer .currency-wrap");

    // Move the element to the end of the footer
    if (currencyEl && footer) {
      footer.appendChild(currencyEl);
    }
  }, 3500); // 2000ms = 2 seconds


  setTimeout(() => {
    const colorLabel = document.querySelector('.PwzrGrid-root-1720 .PwzrGrid-item-1722 > div');
    if (colorLabel) {
      // Remove "Color:" text while keeping the span element
      colorLabel.innerHTML = colorLabel.innerHTML.replace('Color: ', '');
    }
  }, 2000);

  // Define all URLs where you want to hide the buy button
  const hideBuyButtonUrls = [
    "/pages/find-your-colours",
    "/products/the-vanity-case",
    "/products/summer-collection",
    "/products/spring-collection",
    "/products/autumn-collection",
    "/products/winter-collection",
    "/products/build-your-capsule-3-shades"
  ];

  // Check if the current URL matches any of them
  if (hideBuyButtonUrls.some(url => window.location.href.includes(url))) {
    // 1️⃣ Add body class
    document.body.classList.add("find-my-colours");

    
    // 2️⃣ Hide buy buttons
    document.querySelectorAll('header .buy-button').forEach(btn => btn.style.display = 'none');
 

    // 3️⃣ Add custom CSS
    const style = document.createElement('style');
    style.textContent = `
      .header__icon, 
      .header__icon--cart .icon {
        height: 2.5rem !important;
      }
    `;
    document.head.appendChild(style);
  }

 const observer = new MutationObserver(() => {
    const seasonBlock = document.querySelector('[data-option="Season"]');
    const productTitle = document.querySelector('h1.product__title');

    if (seasonBlock && productTitle && !seasonBlock.nextElementSibling?.contains(productTitle)) {
      seasonBlock.insertAdjacentElement('afterend', productTitle);
      observer.disconnect(); // Stop observing once done
    }

     const colorLabel = document.querySelector('.PwzrGrid-root-1720 .PwzrGrid-item-1722 > div');
      if (colorLabel) {
        // Remove "Color:" text while keeping the span element
        colorLabel.innerHTML = colorLabel.innerHTML.replace('Color: ', '');
      }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  //Currency Selector
  (function () {
    const drawer = document.getElementById('menu-drawer');
    if (!drawer) return;

    function findWrapper(btn){
      return btn?.parentElement?.querySelector('.disclosure__list-wrapper.country-selector');
    }

    drawer.addEventListener('click', function (e) {
      // Toggle open
      const btn = e.target.closest('.disclosure__button.localization-form__select');
      if (btn) {
        const wrap = findWrapper(btn);
        if (!wrap) return;
        const willOpen = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        wrap.hidden = !willOpen;

        const overlay = drawer.querySelector('.country-selector__overlay');
        if (overlay) overlay.classList.toggle('is-active', willOpen);
      }

      // Close with "X"
      const closeBtn = e.target.closest('.country-selector__close-button');
      if (closeBtn) {
        const btn = drawer.querySelector('.disclosure__button.localization-form__select[aria-expanded="true"]');
        const wrap = btn ? findWrapper(btn) : null;
        if (btn && wrap) {
          btn.setAttribute('aria-expanded', 'false');
          wrap.hidden = true;
        }
        const overlay = drawer.querySelector('.country-selector__overlay');
        if (overlay) overlay.classList.remove('is-active');
      }
    });

    // Close when tapping overlay
    const overlay = drawer.querySelector('.country-selector__overlay');
    overlay?.addEventListener('click', function () {
      const btn = drawer.querySelector('.disclosure__button.localization-form__select[aria-expanded="true"]');
      const wrap = btn ? findWrapper(btn) : null;
      if (btn && wrap) {
        btn.setAttribute('aria-expanded', 'false');
        wrap.hidden = true;
      }
      overlay.classList.remove('is-active');
    });

    // Close on Escape (accessibility)
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const btn = drawer.querySelector('.disclosure__button.localization-form__select[aria-expanded="true"]');
        const wrap = btn ? findWrapper(btn) : null;
        if (btn && wrap) {
          btn.setAttribute('aria-expanded', 'false');
          wrap.hidden = true;
        }
        const overlay = drawer.querySelector('.country-selector__overlay');
        overlay?.classList.remove('is-active');
      }
    });
  })();

  
  
});


/* LB Upsell (Sense) – Color dot + shade name (NEW long card markup) */
(function () {
  const SHADE_TO_HEX = {
    "1. sunrise swim - light summer": "#F6A6B6",
    "2. a berry smoothie - true summer": "#C75A86",
    "3. morning haze - soft summer": "#C98E9A",
    "4. heels in snow - true winter": "#B0123B",
    "5. frost kissed - bright winter": "#E24A7A",
    "6. fireside wine - deep winter": "#6E1230",
    "7. first bloom - bright spring": "#FF5A7D",
    "8. wildflower bouquet - true spring": "#FF6E88",
    "9. peony picnic - light spring": "#FFA6B8",
    "10. candlelit cabin - deep autumn": "#7A2B2B",
    "11. sunlit rosewood - true autumn": "#8D3B3B",
    "12. cozy afternoon - soft autumn": "#B46B6B"
  };

  function normalizeShadeKey(text) {
    const parts = (text || "").split(" / ");
    return (parts[1] || text || "").trim();
  }

  function prettifyShadeName(key) {
    // "4. heels in snow - true winter" → "4. Heels In Snow"
      const match = key.match(/^(\d+)\.\s*([^–-]+)/i);

      if (!match) return key;

      const number = match[1];
      const name = match[2]
        .trim()
        .replace(/\b\w/g, c => c.toUpperCase());

      return `${number}. ${name}`;
  }

  function injectDot(selectEl) {
    if (!selectEl || selectEl.dataset.lbDotMounted === "true") return;

    const cont = selectEl.closest(".lb-variant-picker-cont");
    if (!cont) return;

    // Wrapper row
    const row = document.createElement("div");
    row.style.display = "flex";
    row.style.alignItems = "center";
    row.style.gap = "8px";
    row.style.marginBottom = "10px";

    // Color dot
    const dot = document.createElement("span");
    dot.style.width = "14px";
    dot.style.height = "14px";
    dot.style.borderRadius = "999px";
    dot.style.border = "1px solid rgba(0,0,0,.2)";
    dot.style.display = "inline-block";
    dot.style.flex = "0 0 14px";

    // Shade name
    const label = document.createElement("span");
    label.style.fontSize = "12px";
    label.style.fontWeight = "400";
    label.style.color = "#444";
    label.style.lineHeight = "1";

    row.appendChild(dot);
    row.appendChild(label);
    cont.insertBefore(row, selectEl);

    const update = () => {
      const opt = selectEl.options?.[selectEl.selectedIndex];
      if (!opt) return;

      const key = normalizeShadeKey(opt.textContent);
      dot.style.background = SHADE_TO_HEX[key] || "#DDD";
      label.textContent = prettifyShadeName(key);
      row.title = key;
    };

    update();
    selectEl.addEventListener("change", update);
    selectEl.addEventListener("input", update);

    selectEl.dataset.lbDotMounted = "true";
  }

  function tryInject() {
    document.querySelectorAll(
      "lb-upsell-long-card select.lb-variant-picker, " +
      ".lb-cta-cont select.lb-variant-picker, " +
      ".lb-popup select.lb-variant-picker"
    ).forEach(injectDot);
  }

  // Delay + retry (Sense cart drawer re-renders)
  function runWithDelay() {
    let attempts = 0;
    const iv = setInterval(() => {
      attempts++;
      tryInject();
      if (attempts >= 12) clearInterval(iv);
    }, 250);
  }

  // Cart open
  document.addEventListener("click", (e) => {
    const cartTrigger = e.target.closest(
      '.header__icon--cart, a[href="/cart"], a[href^="/cart"], button[aria-controls*="cart"]'
    );
    if (cartTrigger) setTimeout(runWithDelay, 400);
  });

  // Upsell interaction
  document.addEventListener("click", (e) => {
    if (e.target.closest("lb-upsell-long-card, .lb-cta-cont, .lb-popup")) {
      setTimeout(runWithDelay, 200);
    }
  });

  // Safety run
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(runWithDelay, 600);
  });
})();




